import PropTypes from "prop-types";
import React, { Component } from "react";
import MessageList from "./MessageList";
import UserInput from "./ChatUserInput";
import CannedMessages from "./Header/CannedMessages/CannedMessages";
import appConstants from "../../../../appConstants";
import MCQMessage from "./Header/MCQMessages";

class ChatWindow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMsg: {},
      cannedMessage: "",
    };
  }

  componentDidUpdate(prevProps) {
    const {openChoiceMessages} = this.props;
    if (prevProps.driverInfo.name !== this.props.driverInfo.name) {
      this.setState({
        selectedMsg: {},
      });
    }
    if (prevProps.openChoiceMessages !== openChoiceMessages) {
      this.setState(prevState => ({
        ...prevState,
        ...(!openChoiceMessages && {cannedMessage: ""}),
      }));
    }
  }

  sendDispatcherMessage = ({message, isUrgent, choice}) => {
    const dispatcherMessage = {
      type: "text",
      sender: "Dispatcher",
      messageType: appConstants.MESSAGE_TYPE.Dispatcher,
      message: message,
      messageDateTs: new Date(),
      isRead: false,
      isUrgent,
      parentMessageId: null,
      parentMessage: {},
      choice,
    };
    if (Object.keys(this.state.selectedMsg).length > 0) {
      dispatcherMessage.parentMessageId = this.state.selectedMsg.messageId;
      dispatcherMessage.parentMessage = {
        type: "text",
        sender: this.state.selectedMsg.sender,
        messageId: this.state.selectedMsg.messageId,
        parentMessageId: null,
        messageDateTs: this.state.selectedMsg.messageDateTs,
        isRead: this.state.selectedMsg.isRead,
        message: this.state.selectedMsg.message,
        metadata: this.state.selectedMsg.metadata,
      };
    }
    this.props.onUserInputSubmit(dispatcherMessage);
    this.props.handleCannedMessageClick(false);
    this.props.handleChoiceMessageClick(false);
    this.setState({
      selectedMsg: {},
      cannedMessage: "",
    });
  };

  onReplyMsgSelected = (msg) => {
    this.setState({ selectedMsg: msg });
    this.props.disableChoiceMessageIcon(true);
  };
  clearReply = () => {
    this.setState({ selectedMsg: {} });
    this.props.disableChoiceMessageIcon(false);
  };

  setCannedMessage = ({message: cannedMessage}) => {
    this.setState({ cannedMessage })
    this.props.handleCannedMessageClick(false);
  }

  isChoiceMessageFlow = () => {
    const {openCannedMessages, openChoiceMessages} = this.props;
    return openCannedMessages && openChoiceMessages;
  }

  isCannedMessageFlow = () => {
    const {openCannedMessages, openChoiceMessages} = this.props;
    return openCannedMessages && !openChoiceMessages;
  }

  render() {
    const { classes, openCannedMessages, loadingMessages, openChoiceMessages } =
      this.props;
    return (
      <React.Fragment>
        {loadingMessages ? (
          <div className={classes.loadingMessage}>fetching chat history</div>
        ) : (
          <MessageList
            classes={classes}
            messages={this.props.messageList}
            driverInfo={this.props.driverInfo}
            openCannedMessages={openCannedMessages}
            onReplyMsgSelected={this.onReplyMsgSelected}
            handleCannedMessageClick={this.props.handleCannedMessageClick}
            selectedMsg={this.state.selectedMsg}
            terminalOffset={this.props.currentTerminalOffset}
          />
        )}

        {!openCannedMessages && !openChoiceMessages  && (
          <UserInput
            driverInfo={this.props.driverInfo}
            classes={classes}
            onSubmit={this.sendDispatcherMessage}
            selectedMsg={this.state.selectedMsg}
            clearReply={this.clearReply}
            addTextCount={this.addTextCount}
          />
        )}
        {openChoiceMessages && (
          <MCQMessage 
            handleChoiceMessageClick={this.props.handleChoiceMessageClick}
            showCannedMessages={this.props.handleCannedMessageClick}
            selectedCannedMessage = {this.state.cannedMessage}
            onMessageSubmit={this.sendDispatcherMessage}
          />
        )}
        {this.isChoiceMessageFlow() && (
          <CannedMessages
            pendingCustomers={this.props.driverInfo.pendingCustomers}
            onMessageSubmit={this.setCannedMessage}
            classes={classes}
            handleCannedMessageClick={this.props.handleCannedMessageClick}
            isChoiceMessageFlow
          />
        )}
        {this.isCannedMessageFlow() && (
          <CannedMessages
            pendingCustomers={this.props.driverInfo.pendingCustomers}
            onMessageSubmit={this.sendDispatcherMessage}
            classes={classes}
            handleCannedMessageClick={this.props.handleCannedMessageClick}
          />
        )}
      </React.Fragment>
    );
  }
}

ChatWindow.propTypes = {
  driverInfo: PropTypes.object.isRequired,
  messageList: PropTypes.arrayOf(PropTypes.object),
  onUserInputSubmit: PropTypes.func.isRequired,
};

export default ChatWindow
